<div class="login-page d-flex flex-column flex-root" id="kt_app_root">
  <div class="d-flex flex-column flex-lg-row flex-column-fluid min-vh-100">
    <!-- Form Side -->
    <div
      class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1"
    >
      <div class="d-flex flex-center flex-column flex-lg-row-fluid">
        <div class="w-lg-500px p-10">
          <div class="text-center mb-11">
            <h1 class="text-gray-900 fw-bolder mb-3" style="font-size: 2.25rem">
              {{ title | translate }}
            </h1>

            <div class="text-gray-500 fw-semibold" style="font-size: 1.25rem">
              {{ "auth.setNewPassword.subtitle" | translate }}
            </div>
          </div>

          <!-- Token Expired Alert -->
          <div
            *ngIf="isValid === false"
            class="alert alert-danger text-center mb-10"
          >
            <i class="fa-solid fa-exclamation-triangle me-2"></i>
            {{ "auth.setNewPassword.tokenExpired" | translate }}
          </div>

          <!-- Set New Password Form -->
          <form
            *ngIf="isValid === true"
            [formGroup]="setNewPasswordForm"
            (submit)="submit($event)"
            class="form w-100"
            novalidate="novalidate"
          >
            <!-- New Password -->
            <div class="fv-row mb-8 position-relative">
              <input
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                [placeholder]="'newPassword' | translate"
                class="form-control bg-transparent"
                [ngClass]="{
                  'is-invalid': isControlInvalid('password')
                }"
              />
              <span
                *ngIf="setNewPasswordForm.get('password')?.value"
                class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                (click)="togglePasswordVisibility('password')"
                style="z-index: 10"
              >
                <i
                  class="fa-solid"
                  [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                ></i>
              </span>
              <div
                *ngIf="isControlInvalid('password')"
                class="invalid-feedback"
              >
                {{ "auth.setNewPassword.passwordRequired" | translate }}
              </div>
            </div>

            <!-- Confirm Password -->
            <div class="fv-row mb-8 position-relative">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                formControlName="confirmPassword"
                [placeholder]="'confirmPassword' | translate"
                class="form-control bg-transparent"
                [ngClass]="{
                  'is-invalid': isControlInvalid('confirmPassword')
                }"
              />
              <span
                *ngIf="setNewPasswordForm.get('confirmPassword')?.value"
                class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                (click)="togglePasswordVisibility('confirmPassword')"
                style="z-index: 10"
              >
                <i
                  class="fa-solid"
                  [ngClass]="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"
                ></i>
              </span>
              <div
                *ngIf="isControlInvalid('confirmPassword')"
                class="invalid-feedback"
              >
                <span
                  *ngIf="setNewPasswordForm.get('confirmPassword')?.errors?.['required']"
                >
                  {{
                    "auth.setNewPassword.confirmPasswordRequired" | translate
                  }}
                </span>
                <span
                  *ngIf="setNewPasswordForm.get('confirmPassword')?.errors?.['notMatching']"
                >
                  {{ "auth.setNewPassword.passwordsDoNotMatch" | translate }}
                </span>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="d-grid mb-10">
              <button type="submit" class="btn btn-primary cursor-pointer">
                <span class="indicator-label">
                  {{ "auth.setNewPassword.submit" | translate }}
                </span>
              </button>
            </div>
          </form>

          <!-- Back to login -->
          <div class="d-grid mb-10">
            <p class="text-center mt-2">
              <a class="text-primary" routerLink="/auth/login">
                <i class="feather icon-chevron-left"></i>
                {{ "backToLogin" | translate }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Image Side -->
    <div
      class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
      style="background-image: url(assets/media/misc/auth-bg.png)"
    >
      <app-welcome-image class="w-100"></app-welcome-image>
    </div>
  </div>
</div>
